import React, { useEffect, useState, useContext } from "react";
import { getShifts } from "../api";
import { LanguageContext } from "../context/LanguageContext";

const ShiftList2 = ({ id_c, onSelect, value }) => {
  const { t } = useContext(LanguageContext);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const res = await getShifts(id_c); // { shifts, total }
      setData(res);
    };
    if (id_c) fetchData();
  }, [id_c]);

  if (!data) return <p>{t("MList1") || "Cargando..."}</p>;

  return (
    <select
      className="input1"
      onChange={(e) => onSelect(e.target.value)}
      value={value || ""}
      required
    >
      <option value="">
        -- {t("shifts1") || "Selecciona un turno"} --
      </option>
      {data.shifts.map((s) => (
        <option key={s.id_shift} value={s.id_shift}>
          {s.id_shift} ({String(s.time_begin).slice(0,5)}–{String(s.time_end).slice(0,5)})
        </option>
      ))}
    </select>
  );
};

export default ShiftList2;
